import { Button, CommentLineIcon, Space } from 'ui';
import { useDirectMessage } from 'features/chat';
import { MemberNavigationButtons } from '../member-navigation-buttons';

type P = {
  member: {
    id: string;
    nodeId?: string;
  };
};

const MemberActions = ({ member: { id, nodeId } }: P) => {
  const { handleDirectMessage, isFetching } = useDirectMessage();

  return (
    <Space block orientation="vertical" size="small">
      <Button
        block
        icon={<CommentLineIcon />}
        loading={isFetching}
        onClick={() => {
          handleDirectMessage({ id });
        }}
        size="large"
        type="primary"
      >
        Send message
      </Button>
      <MemberNavigationButtons memberId={id} nodeUserId={nodeId} />
    </Space>
  );
};

export default MemberActions;
